import { render, staticRenderFns } from "./CustomerHistory.vue?vue&type=template&id=7d1adf0e"
import script from "./CustomerHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerHistory.vue?vue&type=style&index=0&id=7d1adf0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports